import { render, staticRenderFns } from "./NeurologicalAssessmentPanel.vue?vue&type=template&id=2abca3e4&scoped=true&"
import script from "./NeurologicalAssessmentPanel.vue?vue&type=script&lang=js&"
export * from "./NeurologicalAssessmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./NeurologicalAssessmentPanel.vue?vue&type=style&index=0&id=2abca3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abca3e4",
  null
  
)

export default component.exports